<div class="main-container">
  <div class="layout-commandbar outside-layout-control">
    <div class="layout-gutter-left"></div>
    <div class="layout-content outside-layout-control-content">
      <div class="horizontal-container">

        <div class="root-container">
          <div class="inline-command-bar command-bar" role="menubar" data-command-bar="true">

            <div role="presentation" class="action-list-control-container">

              <div class="horizontal-flex-container">


                @for (commandGroup of commandsGroup; track commandGroup; let i = $index) {
                  <!-- Separator -->
                  @if (i > 0) {
                    <div class="navigation-bar-row-separator only-desktop">
                    </div>
                  }
                  <!-- Separator -->
                  @for (command of commandGroup.commands; track trackById($index, command)) {
                    @if (!command.onlyInMoreOptions && (command.isVisible$ | async)) {
                      <div class="horizontal-flex-container-item-layout only-desktop"
                        >
                        <div class="command-bar-button-container">
                          @if (customButtonTemplate) {
                            <ng-container
                                                        *ngTemplateOutlet="customButtonTemplate; context: {
                                                        $implicit: command,
                                                        command: command,
                                                        execute: executeCommand.bind(this),
                                                    }">
                            </ng-container>
                          } @else {
                            <nts-ribbon-button
                              [title]="command.tooltip$ | async"
                              [tabIndex]="0"
                              [isLoading]="(command.loading$ | async)"
                              [commands]="command.children"
                              [label]="(command.showDisplayName$ | async) ? (command.displayName$ | async) : ''"
                              [icon]="command.iconClass$ | async"
                              [isHightlighted]="command.isHighlighted(null) | async"
                              [isDisabled]="!(command.canExecute$ | async)"
                              (onClicked)="executeCommand(command, $event)">
                            </nts-ribbon-button>
                          }
                        </div>
                      </div>
                    }
                  }
                }

                <div class="sticky-area"
                  [hidden]="(!mobileMenuCommand && !moreOptionsCommand) || ( (mobileMenuCommand && !(mobileMenuCommand.isVisible$ | async)) && (moreOptionsCommand && !(moreOptionsCommand.isVisible$ | async)))">

                  <!-- Begin Mobile Menu -->
                  @if ($safeNavigationMigration(mobileMenuCommand?.isVisible$) | async) {
                    <div class="horizontal-flex-container-item-layout extended-layout only-mobile"
                      >
                      <div class="command-bar-button-container">
                        @if (customMobileButtonTemplate) {
                          <ng-container
                                                    *ngTemplateOutlet="customMobileButtonTemplate; context: {
                                                        $implicit: mobileMenuCommand,
                                                        command: mobileMenuCommand,
                                                        execute: mobileMenuClick.bind(this, mobileMenu),
                                                    }">
                          </ng-container>
                        } @else {
                          @if (mobileMenuCommand) {
                            <nts-ribbon-button
                              #mobileMenuButton
                              [title]="mobileMenuCommand.tooltip$ | async"
                              [label]="(mobileMenuCommand.showDisplayName$ | async) ? (mobileMenuCommand.displayName$ | async) : ''"
                              [isLoading]="mobileMenuCommand.loading$ | async"
                              [icon]="mobileMenuCommand.iconClass$ | async"
                              (onClicked)="mobileMenuClick(mobileMenu, $event, mobileMenuButton)">
                            </nts-ribbon-button>
                          }
                        }
                      </div>
                      <p-slideMenu
                        appendTo="body"
                        styleClass="mobile-menu"
                        #mobileMenu
                        [backLabel]="'std_Menu_Back' | NTSTranslate"
                        [baseZIndex]="3000"
                        [menuWidth]="mobileMenuViewportWidth$ | async"
                        [viewportHeight]="mobileMenuViewportHeight$ | async"
                        [model]="mobileMenuItemList$ | async"
                        (onHide)="onSlideMenuHide(mobileMenu)"
                        [popup]="true">
                      </p-slideMenu>
                    </div>
                  }
                  <!-- End Mobile Menu -->

                  <!-- Separator for MoreOptions -->
                  @if (commandsGroup?.length > 0 && moreOptionsCommand?.isVisible$ | async) {
                    <div class="navigation-bar-row-separator only-desktop"
                      >
                    </div>
                  }
                  <!-- End Separator for MoreOptions -->

                  <!-- Begin More -->
                  <div class="horizontal-flex-container-item-layout extended-layout only-desktop"
                    [hidden]="!moreOptionsCommand || !(moreOptionsCommand.isVisible$ | async)">

                    <div class="command-bar-button-container">
                      @if (customMoreOptionButtonTemplate) {
                        <ng-container
                                                    *ngTemplateOutlet="customMoreOptionButtonTemplate; context: {
                                                        $implicit: moreOptionsCommand,
                                                        command: moreOptionsCommand,
                                                        execute: moreOptionClick.bind(this, moreOptionsMenu),
                                                    }">
                        </ng-container>
                      } @else {
                        @if (moreOptionsCommand) {
                          <nts-ribbon-button
                            #moreOptionMenuButton
                            [title]="moreOptionsCommand.tooltip$ | async"
                            [label]="(moreOptionsCommand.showDisplayName$ | async) ? (moreOptionsCommand.displayName$ | async) : ''"
                            [isLoading]="moreOptionsCommand.loading$ | async"
                            [icon]="moreOptionsCommand.iconClass$ | async"
                            (onClicked)="moreOptionClick(moreOptionsMenu, $event, moreOptionMenuButton)">
                          </nts-ribbon-button>
                        }
                      }
                    </div>

                    <p-slideMenu [backLabel]="'std_Menu_Back' | NTSTranslate" [menuWidth]="250"
                      styleClass="more-options-menu" #moreOptionsMenu
                      [baseZIndex]="3000"
                      [viewportHeight]="moreOptionMenuViewportHeight$ | async"
                      [model]="moreOptionsMenuItemList$ | async"
                      (onHide)="onSlideMenuHide(moreOptionsMenu)"
                      [popup]="true" appendTo="body">
                    </p-slideMenu>
                  </div>
                  <!-- Fine More -->
                  @if (defaultCommand && (defaultCommand.isVisible$ | async)) {
                    <div class="default-actions-container"
                      >
                      @if (customDefaultCommandTemplate) {
                        customDefaultCommandTemplate
                        <ng-container
                                                *ngTemplateOutlet="customDefaultCommandTemplate; context: {
                                                        $implicit: defaultCommand,
                                                        command: defaultCommand,
                                                        execute: executeCommand.bind(this, defaultCommand),
                                                    }">
                        </ng-container>
                      } @else {
                        <nts-filled-button
                          [title]="defaultCommand.tooltip$ | async"
                          [label]="(defaultCommand.showDisplayName$ | async) ? (defaultCommand.displayName$ | async) : ''"
                          [icon]="defaultCommand.iconClass$ | async"
                          [isLoading]="defaultCommand.loading$ | async"
                          [type]="defaultCommandType"
                          [isDisabled]="!(defaultCommand.canExecute$ | async)"
                        (onClicked)="executeCommand(defaultCommand, $event)"></nts-filled-button>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="layout-gutter-right"></div>
  </div>
</div>